import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AdminEventModel } from '../../shared/models/admin-event-models';
import { Observable, from } from 'rxjs';
import { AdminAuthService } from './admin-auth.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminEventService {

  constructor(private httpClient: HttpClient, private authService: AdminAuthService) { }
  private adminEventApiBaseUrl = 'api/Admin/Event';

  getAllEvents(): Observable<AdminEventModel[]> {
    return from(this.authService.getToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return this.httpClient.get<AdminEventModel[]>(`${this.adminEventApiBaseUrl}/All`, { headers });
      })
    );
  }

  createEvent(model: AdminEventModel): Observable<boolean> {
    return from(this.authService.getToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return this.httpClient.post<boolean>(`${this.adminEventApiBaseUrl}/CreateNewEvent`, model, { headers });
      })
    );
  }

  updateEvent(model: AdminEventModel): Observable<boolean> {
    return from(this.authService.getToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return this.httpClient.post<boolean>(`${this.adminEventApiBaseUrl}/UpdateEvent`, model, { headers });
      })
    );
  }

  deleteEvent(eventId: number): Observable<boolean> {
    return from(this.authService.getToken()).pipe(
      switchMap(token => {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return this.httpClient.delete<boolean>(`${this.adminEventApiBaseUrl}/DeleteEvent/${eventId}`, { headers });
      })
    );
  }
}
